import _get from 'lodash/get';

import store from 'Redux/store';
import {
  get,
  // post,
  patch,
  put,
  del,
} from 'Api';
import { REFRESH_AUTH } from 'Redux/ducks/auth';

class SteamError extends Error {
  constructor(apiResponse, defaultCode) {
    super();
    Error.captureStackTrace(this, this.constructor);
    this.name = this.constructor.name;
    this.code = _get(apiResponse, 'code', defaultCode);
  }
}

export async function unlink() {
  const { response, data } = await del(store.dispatch, '/user/steam');

  if (response.ok) {
    store.dispatch({ type: REFRESH_AUTH, payload: data });
    return data;
  }

  throw new SteamError(data, 'E006');
}

export async function getRedirectUrl() {
  const { response, data } = await get(store.dispatch, '/user/steam/redirect');

  if (response.ok && data && data.url) {
    return data.url;
  }

  throw new SteamError(data, 'E001');
}

export async function refresh() {
  const { response, data } = await put(store.dispatch, '/user/steam');

  if (response.ok) {
    store.dispatch({ type: REFRESH_AUTH, payload: data });
    return data.steam;
  }

  throw new SteamError(data, 'E007');
}

export async function setSettings(settings) {
  const { response, data } = await patch(store.dispatch, '/user/steam/sync-settings', settings);

  if (response.ok) {
    store.dispatch({ type: REFRESH_AUTH, payload: data });
    return data;
  }

  throw new SteamError(data, 'E009');
}

export async function manualSync() {
  const { response, data } = await patch(store.dispatch, '/user/steam/sync-now');

  if (response.ok) {
    store.dispatch({ type: REFRESH_AUTH, payload: data });
    return data;
  }

  throw new SteamError(data, 'E010');
}
